import instance from './instance';

export const createAiSuggestionForAdjectives = data =>
  instance.post('/ai_suggestions/create_ai_suggestion_for_adjectives', data);

export const createAiSuggestionForReviewSummary = data =>
  instance.post('/ai_suggestions/create_ai_suggestion_for_review_summary', data);
